module.exports = __webpack_public_path__ + "static/media/01.bf5c2285.jpg";